import { useEffect, useRef } from 'react';

import { getPhoneNumber, getSafeUi, useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useUserInputValue } from '@tectonics/prs/user-input-values';

import { getSelectedPaymentTypeCode } from '../user-input-values/get-selected-payment-type-code';
import { shouldDisablePhoneNumberPrefill } from './get-disable-phone-number-prefill-payment-types';

export const useClearPhoneNumberPrefill = (userInputName: string): void => {
  const incomingPayment = useOpenedIncomingPayment();
  const ui = getSafeUi(incomingPayment);

  const [selectedPaymentMethod] = useUserInputValue<string>('selectedPaymentMethod');
  const [selectedEWallet] = useUserInputValue<string>('selectedEWallet');
  const [value, setValue] = useUserInputValue<string>(userInputName);

  const paymentTypeCode = getSelectedPaymentTypeCode(selectedPaymentMethod, selectedEWallet);

  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    if (!shouldDisablePhoneNumberPrefill(ui, paymentTypeCode)) return;
    const merchantPhone = getPhoneNumber(incomingPayment) ?? '';
    if (valueRef.current !== '' && valueRef.current === merchantPhone) setValue('');
  }, [paymentTypeCode, ui, incomingPayment, setValue]);
};
